export enum HeardAboutSource {
    instagram = 'instagram',
    facebook = 'facebook',
    tikTok = 'tikTok',
    google = 'google',
    wordOfMouth = 'wordOfMouth',
    gym = 'gym',
}
